import React, { useState } from "react";
import {
  UserIcon,
  BriefcaseIcon,
  AcademicCapIcon,
  CheckCircleIcon,
  TrophyIcon,
  LanguageIcon,
  Bars3Icon,
  XMarkIcon,
} from "@heroicons/react/24/solid";

const Sidebar = ({ section, setSection }) => {
  const [isOpen, setIsOpen] = useState(false); // Mobile sidebar state

  const menuItems = [
    { key: "personal", label: "Personal Info", icon: <UserIcon className="w-5 h-5" /> },
    { key: "experience", label: "Work Experience", icon: <BriefcaseIcon className="w-5 h-5" /> },
    { key: "education", label: "Education", icon: <AcademicCapIcon className="w-5 h-5" /> },
    { key: "skills", label: "Technical Skills", icon: <CheckCircleIcon className="w-5 h-5" /> },
    { key: "certificates", label: "Certificates & Training", icon: <TrophyIcon className="w-5 h-5" /> },
    { key: "languages", label: "Languages", icon: <LanguageIcon className="w-5 h-5" /> },
  ];

  return (
    <>
      {/* 🔹 Mobile Sidebar Toggle Button */}
      <button
        className="fixed top-20 left-4 z-50 p-2 bg-gray-800 text-white rounded-md md:hidden"
        onClick={() => setIsOpen(true)}
        aria-label="Open Sidebar"
      >
        <Bars3Icon className="w-6 h-6" />
      </button>

      {/* 🔹 Sidebar */}
      <aside
        className={`bg-gray-800 text-white p-5 h-screen fixed top-0 z-50 transition-transform duration-300
        md:w-64 md:block md:left-0 w-64 ${
          isOpen ? "left-0" : "-left-64"
        } md:relative md:translate-x-0`}
      >
        {/* 🔹 Mobile Close Button */}
        <div className="flex justify-between items-center mb-5 md:hidden">
          <h2 className="text-lg font-semibold">Resume Sections</h2>
          <button onClick={() => setIsOpen(false)} aria-label="Close Sidebar">
            <XMarkIcon className="w-6 h-6 text-white" />
          </button>
        </div>

        {/* 🔹 Sidebar Navigation */}
        <ul className="space-y-3">
          {menuItems.map(({ key, label, icon }) => (
            <li
              key={key}
              className={`flex items-center p-3 rounded-lg cursor-pointer transition-all duration-200 ${
                section === key
                  ? "bg-blue-500 text-white"
                  : "bg-gray-700 hover:bg-gray-600"
              }`}
              onClick={() => {
                setSection(key);
                setIsOpen(false);
              }}
            >
              {icon}
              <span className="ml-3">{label}</span>
            </li>
          ))}
        </ul>
      </aside>

      {/* 🔹 Background Overlay (Mobile only) */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}
    </>
  );
};

export default Sidebar;
